import React from "react";
import ReactPortalsRoot from '../ReactPortalsRoot/ReactPortalsRoot';
import PageBuilderContentSelect from './PageBuilderContentSelect';
import ModalWarning from '../ModalWarning/ModalWarning';

class ContentSelector extends React.Component {

	constructor(props) {
	  super(props);

	  this.state = {
	  	dialog: false,
	  };
	};

	render() {
		return (
			<div className="ContentSelector">
				{this.renderContent()}
			</div>
		);
	};

	renderContent() {
      if(this.state.dialog){
        return(
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t('content_for_column')}
                body={<PageBuilderContentSelect onClick={this.props.onContentSelection} />}
                onOK={this.onContentTypePrompt}
                onCancel={this.onContentTypePrompt}
              />,

            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        )
      } else{
        return (
          <button onClick={this.onContentTypePrompt} type="button" className="btn btn-lg btn-block btn-secondary btn-start content-select-btn"><span className="ss-write"></span></button>
        );
      };
	};

	/**
	* Change handlers
	*/

	onContentTypePrompt= () => {
		this.setState({ dialog: !this.state.dialog });
	};


};

export default ContentSelector
